// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file morfi/v1/cmd/outcome_suggestion_vote.proto (package morfi.v1.cmd, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file morfi/v1/cmd/outcome_suggestion_vote.proto.
 */
export const file_morfi_v1_cmd_outcome_suggestion_vote: GenFile = /*@__PURE__*/
  fileDesc("Ciptb3JmaS92MS9jbWQvb3V0Y29tZV9zdWdnZXN0aW9uX3ZvdGUucHJvdG8SDG1vcmZpLnYxLmNtZCKuAQobT3V0Y29tZVN1Z2dlc3Rpb25Wb3RlVXBkYXRlEgoKAnRzGAEgASgDEhUKDW1hcmtldF9wdWJrZXkYAiABKAkSFQoNc3VnZ2VzdGlvbl9pZBgDIAEoCRIUCgx2b3Rlcl9wdWJrZXkYBCABKAkSDAoEa2luZBgFIAEoDRIPCgd1cHZvdGVzGAYgASgEEhEKCWRvd252b3RlcxgHIAEoBBINCgVzY29yZRgIIAEoA2IGcHJvdG8z");

/**
 * @generated from message morfi.v1.cmd.OutcomeSuggestionVoteUpdate
 */
export type OutcomeSuggestionVoteUpdate = Message<"morfi.v1.cmd.OutcomeSuggestionVoteUpdate"> & {
  /**
   * @generated from field: int64 ts = 1;
   */
  ts: bigint;

  /**
   * @generated from field: string market_pubkey = 2;
   */
  marketPubkey: string;

  /**
   * @generated from field: string suggestion_id = 3;
   */
  suggestionId: string;

  /**
   * @generated from field: string voter_pubkey = 4;
   */
  voterPubkey: string;

  /**
   * @generated from field: uint32 kind = 5;
   */
  kind: number;

  /**
   * @generated from field: uint64 upvotes = 6;
   */
  upvotes: bigint;

  /**
   * @generated from field: uint64 downvotes = 7;
   */
  downvotes: bigint;

  /**
   * @generated from field: int64 score = 8;
   */
  score: bigint;
};

/**
 * Describes the message morfi.v1.cmd.OutcomeSuggestionVoteUpdate.
 * Use `create(OutcomeSuggestionVoteUpdateSchema)` to create a new message.
 */
export const OutcomeSuggestionVoteUpdateSchema: GenMessage<OutcomeSuggestionVoteUpdate> = /*@__PURE__*/
  messageDesc(file_morfi_v1_cmd_outcome_suggestion_vote, 0);

